import { Inject, inject, Injectable } from '@angular/core';
import { FUSE_CONFIG } from '@fuse/services/config/config.constants';
import { STORAGE_KEYS } from 'app/core/storage/storage-prefix';
import { merge } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FuseConfigService {
    private _config = new BehaviorSubject(inject(FUSE_CONFIG));

    /**
     * Constructor
     */
    constructor(@Inject(FUSE_CONFIG) config: any) {
        if (localStorage.getItem(STORAGE_KEYS.UI.LAYOUT)) {
            config.layout = localStorage.getItem(STORAGE_KEYS.UI.LAYOUT)
        }

        if (localStorage.getItem(STORAGE_KEYS.UI.SCHEME)) {
            config.scheme = localStorage.getItem(STORAGE_KEYS.UI.SCHEME)
        }

        if (localStorage.getItem(STORAGE_KEYS.UI.THEME)) {
            config.theme = localStorage.getItem(STORAGE_KEYS.UI.THEME)
        }

        this._config = new BehaviorSubject(config);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for config
     */
    set config(value: any) {
        // Merge the new config over to the current config
        const config = merge({}, this._config.getValue(), value);

        // Execute the observable
        this._config.next(config);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    get config$(): Observable<any> {
        return this._config.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resets the config to the default
     */
    reset(): void {
        // Set the config
        this._config.next(this.config);
    }
}
